import {
  FETCH_FORM_DATA,
  FETCH_FORM_DATA_START,
  FETCH_FORM_DATA_SUCCESS,
  FETCH_FORM_DATA_ERROR,
} from './constants'
import {
  buildAsyncAction,
} from 'containers/Async/actions'

const fetchFormData = (projectId) => ({ type: FETCH_FORM_DATA, projectId })
const fetchFormDataStart = () => ({ type: FETCH_FORM_DATA_START })
const fetchFormDataSuccess = () => ({ type: FETCH_FORM_DATA_SUCCESS })
const fetchFormDataError = (error) => ({ type: FETCH_FORM_DATA_ERROR, error })
const startFetchFormDataAsync = buildAsyncAction(
  FETCH_FORM_DATA,
  FETCH_FORM_DATA_START,
  [FETCH_FORM_DATA_SUCCESS, FETCH_FORM_DATA_ERROR]
)

export {
  fetchFormData,
  fetchFormDataStart,
  fetchFormDataSuccess,
  fetchFormDataError,
  startFetchFormDataAsync,
}
